export default __webpack_public_path__ + "static/media/laundry2-before-1920w.e064d35b.webp";